export default "__VITE_ASSET__8425d253__"